module.exports = __webpack_public_path__ + "img/add.d331cf37.png";